import { client } from '../client';
import { UserProfile } from './types/UserProfile';
import { ADMIN_SCOPED_ROLES, getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

type ReinviteUserByIdPayload = {
  frontend_website?: string;
};

export const reinviteUserById = async (
  userId: string,
  payload: ReinviteUserByIdPayload,
  userRole?: string,
): Promise<UserProfile> => {
  const prefix =
    userRole && ADMIN_SCOPED_ROLES.has(userRole)
      ? '/admin'
      : getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<UserProfile>(`${prefix}/users/${userId}/reinvite`, payload);
  return data;
};
